import { createSelector } from 'reselect';

import { QTaskComment } from '../models/Activity';
import { RootState } from 'data/store';

export const selectTaskComments = (state: RootState): Array<QTaskComment> => state.taskComments.comments ?? [];
export const selectTaskCommentsIsLoading = (state: RootState): boolean => state.taskComments.isLoading;
